export default __webpack_public_path__ + "menu-pages-icon.7ca6d01abe590a8ae7bd60a406ee5e4b.svg";